import React, { useState } from 'react';
import _ from 'lodash';

import { DateRangePicker, LocalizationProvider } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';

import TextFieldFormHook from 'src/components/Forms/Inputs';
import Box from '@mui/material/Box/Box';
import { TextField } from '@mui/material';

function DateRangePickerFormHook(props: any) {
  const importedDateProps = _.pick(props, [
    'startText',
    'endText',
    'inputFormat',
    'views',
    'readOnly',
    'minDate',
    'maxDate',
    'views',
    'value'
  ]);

  const [openDatePicker, setOpenDatePicker] = useState(false);

  const { register, errorMessageStartDate, errorMessageEndDate, onChangeDate, idStart, idEnd } = props;

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DateRangePicker
          {...importedDateProps}
          open={openDatePicker}
          onOpen={() => setOpenDatePicker(true)}
          onClose={() => setOpenDatePicker(false)}
          onChange={(newValue: any) => onChangeDate && onChangeDate(newValue)}
          renderInput={(startProps: any, endProps: any) => {
            const { inputProps, label, focused } = startProps;
            const { inputProps: inputPropsEnd, label: labelEnd, focused: focusedEnd } = endProps;
            if (!register) {
              return (
                <React.Fragment>
                  <TextField id={idStart} name={idStart} inputProps={inputProps} label={label} focused={focused} />
                  <Box sx={{ mx: 2 }}> to </Box>
                  <TextField inputProps={inputPropsEnd} label={labelEnd} focused={focusedEnd} id={idEnd} name={idEnd} />
                </React.Fragment>
              );
            }
            return (
              <React.Fragment>
                <TextFieldFormHook
                  id={idStart}
                  name={idStart}
                  register={register}
                  errorMessage={errorMessageStartDate}
                  inputProps={inputProps}
                  label={label}
                  focused={focused}
                  hideErrorMessage={true}
                />
                <Box sx={{ mx: 2 }}> to </Box>
                <TextFieldFormHook
                  inputProps={inputPropsEnd}
                  label={labelEnd}
                  focused={focusedEnd}
                  id={idEnd}
                  name={idEnd}
                  register={register}
                  errorMessage={errorMessageEndDate}
                  hideErrorMessage={true}
                />
              </React.Fragment>
            );
          }}
        />
      </LocalizationProvider>
    </>
  );
}

export default React.memo(DateRangePickerFormHook);
